import { useState, useEffect } from 'react';
import {
  Grid, Card, CardContent, CardMedia, Typography,
  Button, CircularProgress, Snackbar, Alert, Box
} from '@mui/material';
import { addToCart } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import axios from 'axios';


function ProductCategories({ onCategorySelect }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Fetch categories from your API
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/api/categories');
        setCategories(response.data);
      } catch (error) {
        console.error('Failed to fetch categories', error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <Box sx={{ display: 'flex', overflowX: 'auto', mb: 3, pb: 1 }}>
      <Button
        onClick={() => onCategorySelect(null)}
        sx={{ mx: 1, whiteSpace: 'nowrap' }}
      >
        All Products
      </Button>
      {categories.map(category => (
        <Button
          key={category.id}
          onClick={() => onCategorySelect(category.id)}
          sx={{ mx: 1, whiteSpace: 'nowrap' }}
        >
          {category.name}
        </Button>
      ))}
    </Box>
  );
}


function ProductList({ products }) {
  const { updateCart } = useCart();
  const [loading, setLoading] = useState({});
  const [error, setError] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const handleAddToCart = async (productId) => {
    try {
      // Check if token exists
      const token = localStorage.getItem('token');
      if (!token) {
        setError(prev => ({
          ...prev,
          [productId]: 'Login to add to cart'
        }));
        return;
      }

      await addToCart({
        product_id: productId,
        quantity: 1
      });

      await updateCart();
      setShowSuccess(true);
    } catch (error) {
      console.error("Add to cart error:", error.message);
      // Handle expired token
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        navigate('/login');
        return;
      }

      setError(prev => ({
        ...prev,
        [productId]: error.response?.data?.message || 'Failed to add item to cart'
      }));
    }
  };

  return (
    <Grid container spacing={3}>
      {products?.map(product => (
        <Grid item xs={12} sm={6} md={4} key={product.id}>
          <Card>
            <CardMedia
              component="img"
              height="200"
              image={product.image_url}
              alt={product.name}
            />
            <CardContent>
              <Typography variant="h6">{product.name}</Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 1, height: 60, overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {product.description}
              </Typography>
              <Typography variant="body1">₦{product.price.toLocaleString()}</Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleAddToCart(product.id)}
                disabled={loading[product.id]}
                sx={{ mt: 2 }}
              >
                {loading[product.id] ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Add to Cart'
                )}
              </Button>
              {error[product.id] && (
                <Typography color="error" sx={{ mt: 1 }}>
                  {error[product.id]}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
      >
        <Alert severity="success">Item added to cart successfully!</Alert>
      </Snackbar>
    </Grid>
  );
}

export default ProductList;